// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__-oLUC","requiredAsterisk":"Info_requiredAsterisk__MEZLC"};